import {Provider} from "../../model/providers";
import {Action, createReducer, on} from "@ngrx/store";
import {marketActions} from "../actions";
import _ from "lodash";

export interface State {
  currentMarkets: Set<string>
}

export const initialState: State = {
  currentMarkets: new Set<string>()
}

const MarketsReducer = createReducer(initialState,
  on(marketActions.addMarkets, (state, action) => {

    return {
      ...initialState,
      currentMarkets: _.cloneDeep(action.markets)
    };
  }),
  on(marketActions.addMarket, (state, action) => {
    const newCurrentMarkets = new Set(state.currentMarkets);
    newCurrentMarkets.add(action.market);
    return {
      ...state,
      currentMarkets: newCurrentMarkets
    };
  }),
);


export function reducer(state: State | undefined, action: Action): any {
  return MarketsReducer(state, action);
}

